import { de } from 'date-fns/locale';
import { IOptions } from './commonInterfaces';

export const systemColors = {
  GREEN: '#389e0d',
  YELLOW: '#ffa940',
  RED: '#e3262e',
  RED_DARK: '#ba1628',
  BLUE: '#0D6EFD',
  GREY: '#8c8c8c',
  ORANGE: '#FF4500',
  LIGHT_BLUE: '#2db7f5',
  DARK_BLUE: '#333B7C',
  LIGHT_PINK: '#FF9A9A',
  LIGHT_GREY: '#999999',
  GREY_MEDIUM: '#ccc'
};

export const appRoutes = {
  users: 'users',
  clients: 'clients',
  suppliers: 'suppliers',
  products: 'products',
  sales: 'sales',
  contracts: 'contracts',
  expenses: 'expenses',
  expenseTypes: 'expense-types',
  companies: 'companies',
  services: 'services',
  shopping: 'shopping',
  visits: 'visits',
  vehicles: 'vehicles',
  dre: 'dre',
  applications: 'applications'
};

export const apiRoutes = {
  dashboard: 'dashboard',
  dre: appRoutes.dre,
  groups: 'groups',
  users: appRoutes.users,
  products: appRoutes.products,
  sales: appRoutes.sales,
  companies: appRoutes.companies,
  services: appRoutes.services,
  expenses: appRoutes.expenses,
  visits: appRoutes.visits,
  applications: appRoutes.applications,
  vehicles: appRoutes.vehicles,
  expenseTypes: 'expense-types',
  categories: 'categories'
};

export const apiRoutesArray = [
  apiRoutes.dashboard,
  apiRoutes.dre,
  apiRoutes.users,
  apiRoutes.groups,
  apiRoutes.products,
  apiRoutes.sales,
  apiRoutes.companies,
  apiRoutes.expenseTypes,
  apiRoutes.expenses,
  apiRoutes.services,
  apiRoutes.visits,
  apiRoutes.vehicles,
  apiRoutes.categories,
  apiRoutes.applications
];

export const roules = {
  administrator: 'administrador',
  users: 'usuarios',
  products: 'produtos',
  sales: 'vendas',
  contracts: 'contratos',
  saleUserIdChange: 'vendedor_vendas',
  expenses: 'despesas',
  expenseTypes: 'tipos_despesa',
  clients: 'clientes',
  suppliers: 'fornecedores',
  shopping: 'compras',
  visit: 'visitas',
  vehicles: 'veiculos',
  applications: 'aplicacoes',
  developers: 'desenvolvedores'
};

export const enumStatusUserAws = {
  FORCE_CHANGE_PASSWORD: 'FORCE_CHANGE_PASSWORD',
  NEW_PASSWORD_REQUIRED: 'NEW_PASSWORD_REQUIRED',
  CONFIRMED: 'CONFIRMED'
};

export const booleanFilter: IOptions[] = [
  { value: '', label: 'Todos' },
  { value: 'true', label: 'Sim' },
  { value: 'false', label: 'Não' }
];

export const userType = {
  USER: 'USER',
  CLIENT: 'CLIENT',
  SUPPLIER: 'SUPPLIER'
};

export const pageItemsFilter: IOptions[] = [
  { value: '10', label: '10' },
  { value: '50', label: '50' },
  { value: '100', label: '100' },
  { value: '500', label: '500' },
  { value: '1000', label: '1.000' }
];

export const expensesTypesEnum = {
  COMPRAS: 1,
  RETIRADAS: 2, // MUDOU PARA RETIRADAS -> RETI
  COMI: 3,
  DFIX: 4,
  PAGAMENTO: 5,
  IMPOSTOS: 6,
  SEGURO: 7,
  INVESTIMENTOS: 8,
  MKT: 9,
  MPUB: 10,
  COMB: 11,
  PEDAGIO: 12,
  ALIMENTACAO: 13,
  MANUTENCAO: 14,
  EXTRAS: 15,
  EQUIPAMENTOS: 16,
  INSUMOS: 17,
  IPVA: 18,
  REAP: 19,
  TPAGO: 20,
  MOFF: 21,
  EVENT: 22,
  SIMPL: 23,
  FGTS: 24,
  DARF: 25,
  iOUTR: 26,
  ISS: 27
};

export const arrayExpensesTypesEnum: number[] =
  Object.values(expensesTypesEnum);

export const arrayMarketing = [
  expensesTypesEnum.MKT,
  expensesTypesEnum.TPAGO,
  expensesTypesEnum.MOFF,
  expensesTypesEnum.EVENT,
  expensesTypesEnum.MPUB
];

export const arrayImpostos = [
  expensesTypesEnum.IMPOSTOS,
  expensesTypesEnum.SIMPL,
  expensesTypesEnum.MOFF,
  expensesTypesEnum.FGTS,
  expensesTypesEnum.DARF,
  expensesTypesEnum.iOUTR,
  expensesTypesEnum.ISS
];

export const arrayExpenses = [
  expensesTypesEnum.INSUMOS,
  expensesTypesEnum.INVESTIMENTOS,
  expensesTypesEnum.RETIRADAS,
  expensesTypesEnum.COMPRAS
];

export const arrayInput = [expensesTypesEnum.INSUMOS];
export const arrayInvestment = [expensesTypesEnum.INVESTIMENTOS];
export const arrayCashWithdrawal = [expensesTypesEnum.RETIRADAS];

export const productCategoriesEnum = {
  SERVICO: 1,
  INSUMO: 2,
  CUSTO: 3,
  SERVICO_M2: 4
};

export const categorIdsArrayProduct = [
  productCategoriesEnum.SERVICO,
  productCategoriesEnum.SERVICO_M2
];

export const categorIdsArrayCost = [productCategoriesEnum.CUSTO];
